import { Stack } from 'common/ui/Layout';
import Text from 'common/ui/Text';
import { css } from 'styled-components';
import { Colors } from 'styles';
import { formatReportSignedByLabel } from 'utils/date';

export type ReportSignedByLabelProps = {
  firstName: Nullable<string>;
  lastName: Nullable<string>;
  submittedAt: Date;
};

export const ReportSignedByLabel = ({
  firstName,
  lastName,
  submittedAt,
}: ReportSignedByLabelProps): React.ReactElement => {
  const label = formatReportSignedByLabel({ firstName, lastName, submittedAt });
  return (
    <Stack alignY="center" data-testid="report-signed-by-label">
      <Text
        variant="caption"
        css={css`
          color: ${Colors.gray8};
          margin-left: 4px;
        `}
      >
        {label}
      </Text>
    </Stack>
  );
};
